import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: 'Company',
    links: [
      { label: '브랜드 소개', href: '/brand/about' },
      { label: '위생 및 안전 기준', href: '/brand/safety' },
      { label: '아티스트 크루', href: '/brand/artists' },
      { label: '포트폴리오', href: '/portfolio' },
    ],
  },
  {
    title: 'Franchise',
    links: [
      { label: '창업 안내', href: '/franchise/guide' },
      { label: '인테리어 컨셉', href: '/franchise/interior' },
      { label: '예상 수익 분석', href: '/franchise/revenue' },
      { label: '가맹 문의', href: '/community/inquiry' },
    ],
  },
  {
    title: 'Community',
    links: [
      { label: '공지사항', href: '/community/notice' },
      { label: '이벤트', href: '/community/events' },
      { label: '고객 문의', href: '/community/inquiry' },
    ],
  },
  {
    title: 'Contact',
    links: [
      { label: 'contact@seonyul.kr', href: 'mailto:contact@seonyul.kr' },
      { label: '02-1234-5678', href: 'tel:02-1234-5678' },
      { label: '서울시 강남구 청담동 123', href: '#' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] text-white">
      <div className="max-w-[1440px] mx-auto px-5 md:px-16 pt-14 md:pt-20 pb-10 md:pb-12">
        {/* Top Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12 mb-14 md:mb-20">
          {footerLinks.map((col) => (
            <div key={col.title}>
              <p className="text-xs tracking-[0.2em] uppercase font-semibold text-white mb-3">{col.title}</p>
              <div className="w-8 h-px bg-white mb-6" />
              <ul className="flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-[#AAAAAA] hover:text-white transition-colors duration-300 cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-white/10 mb-12" />

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
          <div>
            <div className="flex items-start gap-1.5 mb-4">
              <img
                src="https://public.readdy.ai/ai/img_res/8a4691bb-c8bc-42bc-8a41-719182ce50df.png"
                alt="선율 로고"
                className="w-10 h-10 object-contain flex-shrink-0"
              style={{ filter: 'invert(1)' }}
              />
              <div>
                <p
                  className="text-2xl font-thin text-white tracking-[0.2em] leading-none"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  선율
                </p>
                <p className="text-[9px] tracking-[0.35em] uppercase text-white/35 mt-1">
                  SEONYUL LINE STUDIO
                </p>
                <p className="text-[9px] tracking-[0.25em] text-white/20 mt-0.5 italic">
                  Where Lines Become Art
                </p>
              </div>
            </div>
            <p className="text-xs text-[#666] leading-relaxed">
              © 2026 SEONYUL LINE STUDIO. All rights reserved.<br />
              사업자등록번호: 123-45-67890 | 대표: 김선율
            </p>
          </div>
          <div className="flex items-center gap-5">
            <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center text-[#AAAAAA] hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-instagram-line text-xl" />
            </a>
            <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center text-[#AAAAAA] hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-youtube-line text-xl" />
            </a>
            <a href="#" rel="nofollow" className="w-9 h-9 flex items-center justify-center text-[#AAAAAA] hover:text-white transition-colors duration-300 cursor-pointer">
              <i className="ri-kakao-talk-line text-xl" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
